import type { CopyShape } from "../../intl";

import type { LANGUAGE_SETTINGS_COPY_PT_BR } from "../language-settings.copy";

export const LANGUAGE_SETTINGS_COPY_ES_ES: CopyShape<typeof LANGUAGE_SETTINGS_COPY_PT_BR> = {
  title: "Idioma",
  description:
    "El idioma de Tãmi, de los correos y de las notificaciones. Se guarda en tu cuenta y vale en la web, en el móvil y en el ordenador.",
  groupLabel: "Idioma de Tãmi",
  caption: "Idioma de Tãmi, correos y notificaciones",
  saveError: "No hemos podido cambiar el idioma. Inténtalo de nuevo.",
};
